import { DecimalPipe } from '@angular/common';
import { Component, effect, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { GlobalContants } from 'src/app/common/constants/global.contants';
import { ReportService } from '../../services/report.service';
import { ActivatedRoute } from '@angular/router';
import { ReportsChartEnum } from '../../models/enums/reports.enum';
import { SharedService } from 'src/app/common/services/shared.service';
import { TranslateService } from '@ngx-translate/core';
import FileSaver from 'file-saver';
import { ApiService } from 'src/app/common/services/api.service';
import { actionIdConstants, countryCode } from 'src/app/common/constants/common.contants';
import { UserService } from 'src/app/common/services/user.service';
import { AlertService } from 'src/app/common/components/alert/alert.service';
import { MatDialog } from '@angular/material/dialog';
import { DownloadPropertyReportComponent } from '../download-property-report/download-property-report.component';
import { activityPayload } from 'src/app/common/models/userActivity.model';
import { PropertyCategoryEnum } from '../reports-lists/components/common/propertyCategory.enum';

@Component({
  selector: 'app-property-details-overview',
  templateUrl: './property-details-overview.component.html',
  styleUrls: ['./property-details-overview.component.scss']
})
export class PropertyDetailsOverviewComponent implements  OnChanges {
  @Input() isCategoryMatch: boolean = false;
  @Input() Property_Uid: any;
  @Input() property_cat: any = '';
  @Input() is_multi_parcel=false;

  unitType = GlobalContants.keySymbolContants.squareMeterUnit;
  unitTypeMeter = GlobalContants.keySymbolContants.meter;
  CurrencyCode: any;
  PropertyDetails: any = {};
  param: any;
  loading: boolean = false;
  chartView = ReportsChartEnum;
  downloadLoder: boolean=false;
  isSaudiCheck!: boolean;

  propertyCategoryEnum = PropertyCategoryEnum
  constructor(private sharedService: SharedService,
    private reportService: ReportService,
    private route: ActivatedRoute,
    private decimalPipe: DecimalPipe,
    private translate: TranslateService,
    private userservice: UserService,
    private alert: AlertService,
    private dailog: MatDialog,

  ) {
    this.CurrencyCode = this.sharedService.getStoreValue(GlobalContants.StoreKey.CurrencyCode);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.getPropertyDetails(this.Property_Uid);
  }

  ngOnInit(): void {
     this.isSaudiCheck = this.sharedService.getStoreValue(GlobalContants.StoreKey.countryCode) === countryCode.saudi;

    this.sharedService.language$.subscribe(res => {
      this.getPropertyDetails(this.Property_Uid);
    })
  }


  getPropertyDetails(uid: string) {
    if (this.loading) return;
    this.loading = true;
    this.route.queryParams.subscribe((param: any) => {
      this.param = { ...param }
    })
    this.reportService.PropertyDetail(this.param, uid, this.property_cat).subscribe({
      next: (res: any) => {
        this.loading = false;
        if (res?.data) {
          this.PropertyDetails = { ...res.data };
          this.PropertyDetails['lat']= this.PropertyDetails?.lat ? +this.PropertyDetails.lat : null;
          this.PropertyDetails['lon']= this.PropertyDetails?.lon ? +this.PropertyDetails.lon : null;
          this.PropertyDetails['year_of_build'] = this.PropertyDetails.year_of_build ? new Date(this.PropertyDetails.year_of_build).getFullYear() : null;
          // this.PropertyDetails['frontage'] = this.PropertyDetails.direction_info ? this.directionInfo(this.PropertyDetails.direction_info) : null;
          if(this.PropertyDetails?.property_categories)
           this.PropertyDetails['property_categories'] =  this.PropertyDetails['property_categories'].split(',');
          if(this.PropertyDetails?.land_information) {
            this.PropertyDetails.land_information = this.getSortedPropertyInfo(this.PropertyDetails.land_information, this.property_cat)
          }
          if(this.PropertyDetails?.floors && this.property_cat === 'multi_story_office') {
            this.PropertyDetails['floors'] = this.PropertyDetails?.floors > 1 ? this.PropertyDetails?.floors : "";
          }
        } else {
          this.PropertyDetails = null;
        }
      }, error: (err) => {
        this.PropertyDetails = null;
         this.loading = false;
      }
    })
  }

  getSortedPropertyInfo(info: { [key: string]: any }, property_cat: string): { key: string, value: any }[] {
    let keys = ['land_area', 'frontage', 'setback', 'corners', 'whiteland_tax'];
    if(this.is_multi_parcel){
        keys = keys.filter(e=> e != 'corners');
    }
    const result: { key: string, value: any }[] = [];
    keys.forEach(key => {
      if (key in info) {
        if (info[key])
          result.push({ key, value: info[key] });
        else if (key === 'corners')
          result.push({ key, value: info[key] });
      }
    });
    return result;
  }

  directionInfo(value: any) {
    let sum = 0;
    for (const property in value) {
      sum += +value[property]?.toFixed(5);
    }
    return this.decimalPipe.transform(sum, '1.0-1');
  }
  getRoundOffValue(num: any) {
    if ((typeof num) === 'string') return num;
    if (num === null || num === undefined || isNaN(num)) return '';
    if (num >= 10000 && num < 1000000) {
      if (!this.hasDecimal(num)) {
        const capped = Math.floor((num / 1000) * 10) / 10;  // truncate to 1 decimal without rounding
        return (num % 1000 == 0 ?  capped : capped.toFixed(1) ) + this.translate.instant('thousand');
      }
      return this.decimalPipe.transform((num / 1000), '1.0-1') + this.translate.instant('thousand');
    } else if (num >= 1000000 && num < 1000000000) {
      if (!this.hasDecimal(num)) {
        const capped = Math.floor((num / 1000000) * 10) / 10;  // truncate to 1 decimal without rounding
        return (num % 1000000 == 0 ?  capped : capped.toFixed(1)) + this.translate.instant('million');
      }
      return this.decimalPipe.transform((num / 1000000), '1.0-1') + this.translate.instant('million');
    } else if (num >= 1000000000 && num <= 999999999999) {
      if (!this.hasDecimal(num)) {
        const capped = Math.floor((num / 1000000000) * 10) / 10;  // truncate to 1 decimal without rounding
        return (num % 1000000000 == 0 ?  capped : capped.toFixed(1)) + this.translate.instant('billion');
      }
      return this.decimalPipe.transform((num / 1000000000), '1.0-1') + this.translate.instant('billion');
    } else {
      return this.decimalPipe.transform(num, '1.0-1');
    }
  }
  hasDecimal(num: number) {
    return !Number.isInteger(num);
  }

  getTooltipValue(num: any) {
    if ((typeof num) === 'string') return num;
    if(this.hasDecimal(num)) return num.toFixed(2);
    return num.toString();
  }

  downloadPdfReport() {
    let parm:any;
    this.route.queryParams.subscribe((param: any) => {
        parm = { ...param }
      })
    this.dailog.open(DownloadPropertyReportComponent, {
      width : '296px',
      disableClose: true,
      panelClass: 'custom-dialog-container',
      data: {parm: parm, Property_Uid: this.Property_Uid}
    }).afterClosed().subscribe((downloadOption: string) => {
      if(downloadOption === "close") return;
      this.downloadLoder = true;
      this.reportService.downloadPdfPropertyDetail(parm, this.Property_Uid, downloadOption).subscribe({
        next: (data: any) => {
          this.downloadLoder = false;
          this.alert.success(this.translate.instant('reports.reportDownloadedSuccessfully'));
          if (data.body) {
            const blob = new Blob([data.body], { type: 'application/pdf' })
            FileSaver.saveAs(blob, `Property Report - ${this.Property_Uid}.pdf`)
          }
          // Track user activity for download pdf
          const activity:activityPayload = {
            userdata: { property_id: this.PropertyDetails.property_id, property_uid: this.Property_Uid, download_option: downloadOption},
            actionId: actionIdConstants.Pdf_Download,
            entityId: parm.rid,
            entity: 'report',
          }
          this.userservice.logUserActivity(activity);
        }, error: () => {
          this.alert.error("PDF generation failed");
          this.downloadLoder = false;
        }
      })
    })

  }
  getUniqueValues(value: string): string[] {
  if (!value) return [];
  return [...new Set(
    value
      .split(',')               // split by comma
      .map(v => v.trim())        // remove spaces
      .filter(v => v)            // remove empty values
  )];
}
openInGoogleMaps() {
  const lat = this.PropertyDetails?.lat;
  const lon = this.PropertyDetails?.lon;
  // const projectName = encodeURIComponent(this.ProjectDetails.project_name || 'Project');
  const url = `https://www.google.com/maps?q=${lat},${lon}&zoom=18z`;
  // const url = `https://www.google.com/maps/@${lat},${lon},17z`;
  // const url = `https://www.google.com/maps?q=${projectName}+@${this.projectLat},${this.projectLon},18z`;
  window.open(url, '_blank');
}
}
